/*

=========================================================
* Now UI Kit React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-kit-react
* Copyright 2019 Creative Tim (http://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-kit-react/blob/master/LICENSE.md)

* Designed by www.invisionapp.com Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

// styles for this kit
import "assets/css/bootstrap.min.css";
import "assets/scss/now-ui-kit.scss";
import "assets/demo/demo.css";
import "assets/demo/nucleo-icons-page-styles.css";
// pages for this kit
import Index from "views/Index.js";
import NucleoIcons from "views/NucleoIcons.js";
import LoginPage from "views/examples/LoginPage.js";
import LandingPage from "views/examples/LandingPage.js";
import ProfilePage from "views/examples/ProfilePage.js";
import * as serviceWorker from "./serviceWorker";
import {
  GoogleReCaptchaProvider,
  GoogleReCaptcha,
} from "react-google-recaptcha-v3";

ReactDOM.render(
  <GoogleReCaptchaProvider
    reCaptchaKey="6LfAMvgUAAAAAKbS6_xsU2df9lwa99GdTiYiIjyY"
    // language="[optional_language]"
    useRecaptchaNet="[optional_boolean_value]"
  >
    <GoogleReCaptcha onVerify={(token) => console.log(token)} />
    <BrowserRouter>
      <Switch>
        <Switch>
          <Route exact path="/" render={(props) => <Index {...props} />} />
          {/* <Route exact path="/blog" /> */}

          {/* <Route
          path="/nucleo-icons"
          render={(props) => <NucleoIcons {...props} />}
        />
        <Route
          path="/landing-page"
          render={(props) => <LandingPage {...props} />}
        />
        <Route
          path="/profile-page"
          render={(props) => <ProfilePage {...props} />}
        />
        <Route
          path="/login-page"
          render={(props) => <LoginPage {...props} />}
        /> */}

          {/* <Redirect to="/" />
          <Redirect from="/" to="/" /> */}
        </Switch>
      </Switch>
    </BrowserRouter>
  </GoogleReCaptchaProvider>,
  document.getElementById("root")
);

serviceWorker.register();
